module.exports = __webpack_public_path__ + "media/images/vehicles/compact_sedan_toyota_corolla-1d1f5d3094ad82ddf1b1f088f67605db.jpg";